function formatText(key: string): string {
  return typeof key === 'string' ? key
    .split(/[: ]/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ") : key;
}

export const formatLabel = (key: string): string => {
  return typeof key === 'string'
    ? key
        .split(/[:_-]/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : key;
}

export const convertToUnderscore = (key: string): string => {
  return typeof key === 'string'
    ? key
        .split(/[:_-]/)
        .map((word) => word.charAt(0).toLowerCase() + word.slice(1))
        .join('_')
    : key;
}

export { formatText };
export default formatText;

// ─── Smart Search: series-number stripping ───────────────────────────────────

const TITLE_SEPARATOR = ' · ';

/** Strips HTML tags so highlighted titles (<em>…</em>) can be inspected as plain text. */
function stripHtmlTags(html: string): string {
  return html.replace(/<[^>]*>/g, '');
}

function isSeriesNumber(segment: string): boolean {
  const plain = stripHtmlTags(segment).trim();
  return (
    /^[A-Z][A-Z0-9-]+$/.test(plain) &&
    plain.includes('-') &&
    /\d/.test(plain)
  );
}

export function removeSeriesFromTitle(title: string): string {
  if (!title) return title;
  const parts = title.split(TITLE_SEPARATOR);
  const filtered = parts.filter((part) => !isSeriesNumber(part));
  return filtered.join(TITLE_SEPARATOR);
}
